import React, { useEffect, useState } from 'react';
import NetworkStatusPopup, { NETWORK_STATUS } from 'client/components/common/Popups/NetworkStatusPopup';

const NetworkStatus = () => {
  const [status, setStatus] = useState(NETWORK_STATUS.ONLINE);

  useEffect(() => {
    const onlineListener = () => {
      setStatus((prev) => (prev === NETWORK_STATUS.OFFLINE ? NETWORK_STATUS.RESTORED : NETWORK_STATUS.ONLINE));
    };
    const offlineListener = () => {
      setStatus(NETWORK_STATUS.OFFLINE);
    };

    window.addEventListener('online', onlineListener, false);
    window.addEventListener('offline', offlineListener, false);
    return () => {
      window.removeEventListener('online', onlineListener);
      window.removeEventListener('offline', offlineListener);
    };
  }, []);

  return <NetworkStatusPopup status={status} />;
};

export default NetworkStatus;
